module.exports = __webpack_public_path__ + "static/media/21-3.84f7c5c2.mp3";